/**
 * The kanban strip's columns and their measures. A plain module, so the
 * opened board's size (`lib/focus/focus-opened-size.ts`) reads them without
 * importing the board component.
 */
import type { TaskStatus } from "@/api/tasks";

/** The 6 columns displayed in the board, in order. */
export const KANBAN_COLUMNS: readonly TaskStatus[] = [
  "backlog",
  "todo",
  "in_progress",
  "blocked",
  "in_review",
  "done",
];

/**
 * A column's width in an opened board, in px: its cards' titles read
 * without cramping. Columns still shrink to `KANBAN_COLUMN_MIN_W`.
 */
export const BOARD_OPEN_COLUMN_W = 140;

/**
 * The narrowest a column gets, in px. Columns share the strip's width
 * evenly, so a window narrower than six columns at their opened width (a
 * desktop widget, a small frame) still shows every column down to about
 * 450px before the strip scrolls sideways.
 */
export const KANBAN_COLUMN_MIN_W = 64;

/** The strip's `gap-2` between columns, in px. */
export const KANBAN_COLUMN_GAP = 8;
